export enum VEStatus {
  Fail = 'Fail',
  NotAcceptable = 'Not Acceptable',
  FurtherInspect = 'Further Inspect',
  Acceptable = 'Acceptable',
  NotApplicable = 'N/A',
}
